import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MaisView from '@/views/MaisView.vue'
import RelatDespesaSemanal from '@/views/mais/RelatDespesaSemanal.vue'

import PagarView from '@/views/PagarView.vue'
import PagarCadastro from '@/views/pagar/CadastroPagar.vue'
import CartaoCredito from '@/views/pagar/CartaoCredito.vue'


import ReceitaCadastro from '@/views/receber/CadastroReceber.vue'


import CaixaCadastro from '@/views/caixa/CadastroCaixa.vue'



const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true } // precisa estar logado
  },
  {
    path: '/mais',
    name: 'mais',  
    component: MaisView,
    meta: { requiresAuth: true } // precisa estar logado
  },  
  {
    path: '/gastos',
    name: 'gastos',  
    component: PagarView,
    meta: { requiresAuth: true } // precisa estar logado
  },   
  {
    path: '/gastos/novo/:id',
    name: 'gastos-novo',  
    component: () => import('@/views/pagar/NovoPagar.vue'),
    meta: { requiresAuth: true } // precisa estar logado
  },   
  {
    path: '/gastos/cadastro',
    name: 'gastos-cadastro',  
    component: PagarCadastro,
    meta: { requiresAuth: true } // precisa estar logado
  },   
  {
    path: '/gastos/cartao',
    name: 'cartao',  
    component: CartaoCredito,
    meta: { requiresAuth: true } // precisa estar logado
  },     
  {
    path: '/mais/relatdespesasemanal',
    name: 'relatdespesasemanal',  
    component: RelatDespesaSemanal,
    meta: { requiresAuth: true } // precisa estar logado
  },
  {
    path: '/receitas/cadastro',
    name: 'receitas-cadastro',  
    component: ReceitaCadastro,
    meta: { requiresAuth: true } // precisa estar logado
  },
  {
    path: '/caixa/cadastro',
    name: 'caixa-cadastro',  
    component: CaixaCadastro,
    meta: { requiresAuth: true } // precisa estar logado
  },  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})




export default router
